module.exports = __webpack_public_path__ + "static/devsonket-7c7b56622758f9a393f2787368987d56.jpg";